

const Dimensions = [
    {
        height                                : 380,
	
        width                                 : 1260,
        

    },


];

export { Dimensions };